import * as Sentry from '@sentry/browser';

if (process.env.NODE_ENV === 'production') {
  Sentry.init({
    dsn: 'https://222fec0abfe343fd860c5ddc6d3cfdcd@sentry.io/1866807',
  });
}
